var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    stroke: "#929292",
    strokeWidth: 2.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2222 2H5.77778C3.69137 2 2 3.69137 2 5.77778V32.2222C2 34.3086 3.69137 36 5.77778 36H32.2222C34.3086 36 36 34.3086 36 32.2222V5.77778C36 3.69137 34.3086 2 32.2222 2Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.389 15.2222C13.9538 15.2222 15.2223 13.9537 15.2223 12.3889C15.2223 10.8241 13.9538 9.55554 12.389 9.55554C10.8242 9.55554 9.55565 10.8241 9.55565 12.3889C9.55565 13.9537 10.8242 15.2222 12.389 15.2222Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24.6666L26.5555 15.2222L5.77777 35.9999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.b9c073a97e8ccdb89defe0ba8f5d18ac.svg";
export { ForwardRef as ReactComponent };